import { render, staticRenderFns } from "./SuggestionLayout.vue?vue&type=template&id=39aab1a2"
import script from "./SuggestionLayout.vue?vue&type=script&lang=ts"
export * from "./SuggestionLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports